import React from 'react';
import * as R from 'ramda';

export const DashboardCard = ({ userService, index, setSelectedService, userLetters, isLoadingLetters, hasDocumentSending }) => {

    const dateParts = userService.mostRecentDate.substring(0, 10).split('-');
    let displayDate = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
    let noneLetter = ["Rempli", "Non rempli", "Lettres générées", "En traitement..."];
    let greenStatus = ["Lettres validées", "Lettres imprimées", "Lettres postées", "Lettres distribuées", "Traité", "En livraison"];
    let blueStatus = ["Rempli", "Lettres générées", "En traitement..."];
    let displayText = "Générées";
    //let status = "Lettres validées";

    function getAllLettersEqualTo(userLetters, properties) { return userLetters.every(letter => properties.includes(letter.letterProgressStage)); };
    function getSomeLettersEqualTo(userLetters, property) { return userLetters.some(letter => letter.letterProgressStage === property); };
    function allLetterHaveStatus(userLetters, status) { return userLetters.every(letter => letter.letterProgressStage === status); };

    function getLetterHistoryDate(userLetters, letterProgressStage) {
        userLetters = userLetters.filter(ul => ul.letterProgressStage === letterProgressStage);
        let letterHistories = [];
        for (let i = 0; i < userLetters.length; i++) {
            var correspondingHistory = userLetters[i].letterHistory.filter(l => l.letterProgressStage === letterProgressStage);
            letterHistories = R.concat(letterHistories, correspondingHistory);
        }
        if (R.isEmpty(letterHistories)) {
            return "";
        }
        const sortedHistory = R.sortBy(R.prop('date'))(letterHistories);
        const sortedHistoryParts = sortedHistory[0].date.substring(0, 10).split('-');
        return sortedHistoryParts[2] + "-" + sortedHistoryParts[1] + "-" + sortedHistoryParts[0];
    }

    let userLettersFiltered = userLetters.filter(ul => userService.serviceDatas.some(sd => sd.id === ul.userServiceId));
    let status;
    let isClickable = true;

    if (!R.isEmpty(userService.serviceDatas)) {
        status = "En traitement...";

        const userLettersCreated = R.isEmpty(userLettersFiltered) ? false : userLettersFiltered.some(letter => letter.letterProgressStage === "Created");
        // const userLettersValidated = getSomeLettersEqualTo(userLettersFiltered, "Validated");
        const userLettersValidated = getAllLettersEqualTo(userLettersFiltered, ["Validated", "Abandonned"]);
        const userLettersPrinted = getSomeLettersEqualTo(userLettersFiltered, "Printed");
        const userLettersSentPost = getSomeLettersEqualTo(userLettersFiltered, "SentToPost");
        const userLettersInDelivery = getSomeLettersEqualTo(userLettersFiltered, "InDelivery");
        const userLettersDelivered = getSomeLettersEqualTo(userLettersFiltered, "Delivered");
        const userLettersAbandonned = allLetterHaveStatus(userLettersFiltered, "Abandonned");

        if (userLettersCreated) {

            status = "Lettres générées";
            displayDate = getLetterHistoryDate(userLettersFiltered, "Created");

        } else if (userLettersAbandonned) {
            status = "Traité";
            displayText = "Traitées";
            displayDate = getLetterHistoryDate(userLettersFiltered, "Abandonned");
            if(!hasDocumentSending){
                // Requested by Aurélie on 23/07/2026
                // isClickable = false;
            }
        } else if (userLettersValidated) {

            status = "Lettres validées";
            displayText = "Validées";
            displayDate = getLetterHistoryDate(userLettersFiltered, "Validated");

        } else if (userLettersPrinted) {

            status = "Lettres imprimées";
            displayText = "Imprimées";
            displayDate = getLetterHistoryDate(userLettersFiltered, "Printed");

        } else if (userLettersSentPost) {

            status = "Lettres postées";
            displayText = "Postées";
            displayDate = getLetterHistoryDate(userLettersFiltered, "SentToPost");

        } else if (userLettersInDelivery) {

            status = "En livraison";
            displayText = "En livraison";
            displayDate = getLetterHistoryDate(userLettersFiltered, "InDelivery");

        }
        
        else if (userLettersDelivered) {

            status = "Lettres distribuées";
            displayText = "Distribuées";
            displayDate = getLetterHistoryDate(userLettersFiltered, "Delivered");
        }


    } else {

        status = "Non rempli";

    }
    return (
        <div className="form-group col col-lg-3 col-xl-2" key={"servicecard_" + index}>

            {
                isClickable ?
                    <div className={"card rounded p-2 text-center picker-card paper-shadow--hover border-none is-valid" + (greenStatus.includes(status) ? ' bg-alert-secondary' : ' ') + (status === "Non rempli" ? ' bg-alert-danger' : ' ') + (blueStatus.includes(status) ? ' bg-alert-info' : " ")} data-toggle="modal" data-target="#validation" onClick={
                        (e) => {
                            e.preventDefault();
                            setSelectedService(userService);
                        }
                    }>
                        <div className="card-column p-0">
                            <img className="img-fluid mx-auto my-3 mb-2 py-1 img-service" src={userService.icon} alt={userService.title} />
                            <h3 className="h6 text-uppercase font-weight-bolder mx-auto mt-auto">{userService.title}</h3>
                            <p className={"small font-weight-demi mt-auto lh-copy o-0 mb-2"}>Valide</p>
                            <div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center bg-white mt-auto mb-1"}>
                                <div className={"progress-bar h-100 rounded-inherit o-10 w-100 bg-secondary" + (greenStatus.includes(status) ? ' bg-secondary' : ' ') + (status === "Non rempli" ? ' bg-alert-danger' : ' ') + (blueStatus.includes(status) ? ' bg-info' : " ")} role="progressbar"></div>
                                <div className={"h5 d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary loading-btn" + (/*isLoadingLetters.includes(userService.title)*/ true ? ' show' : " ") + (status === "Non rempli" ? ' text-danger' : " ") + (blueStatus.includes(status) ? ' text-info' : " ") + (greenStatus.includes(status) ? ' text-secondary' : " ")} role="progressbar">
                                    {!isLoadingLetters.includes(userService.title) ?
                                        status
                                        :
                                        <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>}
                                </div>
                            </div>
                        </div>
                        <p className={"small font-weight-demi mt-auto lh-copy o-100 text-gray mb-1 w-100 picker-validated" + (greenStatus.includes(status) ? ' bg-alert-secondary' : ' ') + (status === "Non rempli" ? ' bg-alert-danger' : ' ') + (blueStatus.includes(status) ? ' bg-alert-info' : " ")}>{displayText} le<br /><span className="text-dark">{displayDate}</span></p>
                    </div>
                :
                    <div className={"card rounded p-2 text-center picker-card paper-shadow--hover border-none is-valid" + (greenStatus.includes(status) ? ' bg-alert-secondary' : ' ') + (status === "Non rempli" ? ' bg-alert-danger' : ' ') + (blueStatus.includes(status) ? ' bg-alert-info' : " ")}>
                        <div className="card-column p-0">
                            <img className="img-fluid mx-auto my-3 mb-2 py-1 img-service" src={userService.icon} alt={userService.title} />
                            <h3 className="h6 text-uppercase font-weight-bolder mx-auto mt-auto">{userService.title}</h3>
                            <p className={"small font-weight-demi mt-auto lh-copy o-0 mb-2"}>Valide</p>
                            <div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center bg-white mt-auto mb-1"}>
                                <div className={"progress-bar h-100 rounded-inherit o-10 w-100 bg-secondary" + (greenStatus.includes(status) ? ' bg-secondary' : ' ') + (status === "Non rempli" ? ' bg-alert-danger' : ' ') + (blueStatus.includes(status) ? ' bg-info' : " ")} role="progressbar"></div>
                                <div className={"h5 d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary loading-btn" + (/*isLoadingLetters.includes(userService.title)*/ true ? ' show' : " ") + (status === "Non rempli" ? ' text-danger' : " ") + (blueStatus.includes(status) ? ' text-info' : " ") + (greenStatus.includes(status) ? ' text-secondary' : " ")} role="progressbar">
                                    {!isLoadingLetters.includes(userService.title) ?
                                        status
                                        :
                                        <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>}
                                </div>
                            </div>
                        </div>
                        <p className={"small font-weight-demi mt-auto lh-copy o-100 text-gray mb-1 w-100 picker-validated" + (greenStatus.includes(status) ? ' bg-alert-secondary' : ' ') + (status === "Non rempli" ? ' bg-alert-danger' : ' ') + (blueStatus.includes(status) ? ' bg-alert-info' : " ")}>{displayText} le<br /><span className="text-dark">{displayDate}</span></p>
                    </div>
            }



        </div>
    );
};